import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { download } from "../../../functions/download";
import { setDocTitle } from "../../../functions/HelperFuncs";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      id: this.$options.name,
      selectedFiles: [],
      selectedFolders: [],
      collectionId: this.$route.params.id,
      actionBtns: {},
    };
  },
  created() {
    this.setActionBtns();

    this.addBtnListeners();

    EventBus.$on(`files-holder-update`, (data) => {
      //update selected files and folders
      Object.keys(data).forEach((key) => {
        if (data[key] && this[key]) {
          this[key] = data[key];
        }
      });
    });

    setDocTitle("Collection for download", this);
  },
  methods: {
    addBtnListeners() {
      [...this.actionBtns.defaultBtns, ...this.actionBtns.selectedBtns].forEach(
        (btn) => {
          EventBus.$on(btn.emitterName, (e) => {
            if (btn.func) {
              btn.func(e);
            } else {
              this.openRightSidebar(
                btn.emitterName.substring(btn.emitterName.lastIndexOf("-") + 1),
                {}
              );
            }
          });
        }
      );
    },
    openRightSidebar(id, data) {
      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data: data,
      });
    },
    setActionBtns() {
      this.actionBtns = {
        defaultBtns: [
          {
            name: i18n.t("collection.download_collection"),
            icon: "download",
            emitterName: `${this.id}-downloadCollection`,
            rights: ["download_files"],
            func: (e) => this.downloadCollection(e),
          },
        ],
        selectedBtns: [
          {
            name: i18n.t("common.remove"),
            icon: "delete--alt",
            emitterName: `${this.id}-deleteCollectionItem`,
            rights: ["collect"],
            useMySpace: true,
            showOnMySpace: true,
            func: (e) => this.deleteDownloadItem(e),
          },
        ],
      };
    },
    createDownloadLink() {
      return `${baseUrl}/collectiondownload?collection=${
        this.collectionId
      }&company=${this.$store.state.company}${
        this.$store.state.user ? `&key=${this.$store.state.user.key}` : ""
      }`;
    },

    downloadCollection(e) {
      download(
        {
          type: "multi",
          items: {
            selectedFiles: [...this.$store.state.collectForDownload],
            selectedFolders: [],
            collection: {},
          },
          btn: e.event.currentTarget,
        },
        this
      );
    },
    deleteDownloadItem() {
      const toRemoveFiles = [...this.$store.state.transferItems.selectedFiles];
      let newDownloadCollection = [...this.$store.state.collectForDownload];

      newDownloadCollection = newDownloadCollection.filter((colItem) => {
        let keep = true;

        toRemoveFiles.forEach((delFile) => {
          if (delFile.id === colItem.id) {
            //delete me
            keep = false;
          }
        });

        return keep;
      });

      //reset selectedFiles
      this.$store.state.transferItems = {
        ...this.$store.state.transferItems,
        selectedFiles: [],
      };

      //set new download collection
      localStorage.setItem(
        "collectForDownload",
        JSON.stringify(newDownloadCollection)
      );

      this.$store.state.collectForDownload = newDownloadCollection;
    },
    openFileIfPresent() {
      //get file id
      const fileId = this.$route.params.file;

      if (fileId) {
        //get file
        const file = this.$store.state.collectForDownload.find(
          (file) => file.id === fileId
        );

        // open side nav item
        setTimeout(() => {
          EventBus.$emit(`right-sidebar-show`, {
            id: "file",
            data: file,
          });
        }, 300);
      }
    },

    checkUrlForBigChanges() {
      return this.$route.path.includes(
        `/${this.$store.state.company}/collection/expanded/${this.collectionId}`
      );
    },
  },
  watch: {
    "$store.state.collectForDownload"() {},
  },
};
